import React from 'react';

import { ResultContainer, ResultDesktopTitleContainer } from './Results.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';

export const Results: React.FC = () => {
  return (
    <ResultContainer>
      <ResultDesktopTitleContainer>
        <Heading tag="h1" noMargin>
          My Results
        </Heading>
      </ResultDesktopTitleContainer>
      <Text fontStyle="regular" size="lg">
        Overview of all your appointments and their respective results here.
      </Text>
    </ResultContainer>
  );
};
